export enum NavigationSectionType {
  Menu = 'Menu',
  Deal = 'Deal',
  Home = ''
}
